import { put, takeEvery, all } from "redux-saga/effects";
import { CHECK_SCREENING_CL, GET_COLLECTION_CENTER_BY_LEVEL_CL, GET_DECLINE_REASONS_CL, POST_ADHESION_CL, POST_DECLINE_CL } from "./actionsType";
import { checkScreeningCLActionSuccess, getCollectionCenterByLevelCLActionSuccess, getDeclineReasonsCLActionSuccess, getGeolocationsActionSuccess, } from "./actions";
import { LOADING, LOADING_BLOCKING } from "../../global/statusLabels";
import { TIMEOUT, apiProfilazioneGW, apiProfilazioneTS } from "../../api/api";
import { generateHeadersCfTns } from "../../auth/authFunctions";
import { resetMessaggioStateAction, setMessaggioAction, setSnackbarAction } from "../messaggio/actions";
import { ERRORE_GENERICO_API, ERRORE_SESSION_EXPIRED, ERRORE_UNAUTHORIZED, OPERATION_ERROR, OPERATION_SUCCEDED } from "../../global/messaggioLabels";
import { ROOT } from "../../global/urlMapping";
import { checkScreeningCLApiSPID, checkScreeningCLApiTS, getCollectionCenterByLevelCLApiSPID, getCollectionCenterByLevelCLApiTS, getDeclineReasonsCLApiSPID, getDeclineReasonsCLApiTS, postAdhesionCLApiSPID, postAdhesionCLApiTS, postDeclineCLApiSPID, postDeclineCLApiTS } from "../../api/apiFunctionsScreeningColonRetto";
import { generaLog } from "../../functions/utils";

function* checkScreeningCLWorker() {
    generaLog("checkScreeningCLWorker", "log")
    yield put(checkScreeningCLActionSuccess({ value: undefined, status: LOADING }))
    yield put(setMessaggioAction({ status: LOADING_BLOCKING, timeout: TIMEOUT }))
    let response;
    try {
        if (sessionStorage.CFTNS) {
            response = yield checkScreeningCLApiTS()
        } else {
            response = yield checkScreeningCLApiSPID()
        }
        yield put(checkScreeningCLActionSuccess({ value: response?.data, status: response?.status }))
        yield put(resetMessaggioStateAction())
    } catch (error) {
        generaLog(error, "log")
        let bodyError;
        //TAPPULLO PER GATEWAY
        if (sessionStorage.CFTNS) {
            bodyError = error?.response?.data
        }
        else {
            bodyError = JSON.parse(error?.response?.data?.dettaglio)
        }

        if (error?.response?.status === 401) {
            yield put(setMessaggioAction({ status: ERRORE_UNAUTHORIZED }))
        } else if (error?.response?.status === 400) {
            yield put(resetMessaggioStateAction())
        } else if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
        } else {
            yield put(setMessaggioAction({ status: ERRORE_GENERICO_API }))
        }
        yield put(checkScreeningCLActionSuccess({ value: bodyError, status: error?.response?.status }))

    }
}

function* checkScreeningCLWatcher() {
    yield takeEvery(CHECK_SCREENING_CL, checkScreeningCLWorker);
}

function* postDeclineCLWorker() {//NON UTILIZZATA!
    generaLog("postDeclineCLWorker", "log")
    yield put(setMessaggioAction({ status: LOADING_BLOCKING, timeout: TIMEOUT }))
    let response;
    try {
        if (sessionStorage.CFTNS) {
            response = yield postDeclineCLApiTS()
        } else {
            response = yield postDeclineCLApiSPID()

        }
        if (response?.status === 200) {
            yield put(resetMessaggioStateAction())
            yield put(setSnackbarAction(OPERATION_SUCCEDED))

        }
    } catch (error) {
        if (error?.response?.status === 401) {
            yield put(setMessaggioAction({ status: ERRORE_UNAUTHORIZED }))
        } else if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
        } else {
            yield put(setMessaggioAction({ status: ERRORE_GENERICO_API }))
        }

    }
}

function* postDeclineCLWatcher() {
    yield takeEvery(POST_DECLINE_CL, postDeclineCLWorker);
}

function* postAdhesionCLWorker(withdrawalMethod) {
    generaLog("postAdhesionCLWorker", "log")
    yield put(setMessaggioAction({ status: LOADING_BLOCKING, timeout: TIMEOUT }))
    let response;
    try {
        if (sessionStorage.CFTNS) {
            response = yield postAdhesionCLApiTS(withdrawalMethod.payload)
        } else {
            response = yield postAdhesionCLApiSPID(withdrawalMethod.payload)

        }
        if (response?.status === 200) {

            yield put(resetMessaggioStateAction())
            yield put(setSnackbarAction(OPERATION_SUCCEDED))
            window.location.href = ROOT;

        }
    } catch (error) {
        if (error?.response?.status === 401) {
            yield put(setMessaggioAction({ status: ERRORE_UNAUTHORIZED }))
        } else if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
        }
        else {

            yield put(resetMessaggioStateAction())
            yield put(setSnackbarAction(OPERATION_ERROR))
        }


    }
}

function* postAdhesionCLWatcher() {
    yield takeEvery(POST_ADHESION_CL, postAdhesionCLWorker);
}

function* getDeclineReasonsCLWorker() {
    generaLog("getDeclineReasonsCLWorker", "log")
    yield put(getDeclineReasonsCLActionSuccess({ value: undefined, status: LOADING }))
    yield put(setMessaggioAction({ status: LOADING }))
    let response;
    try {
        if (sessionStorage.CFTNS) {
            response = yield getDeclineReasonsCLApiTS()
        } else {
            response = yield getDeclineReasonsCLApiSPID()

        }
        if (response?.status === 200) {
            yield put(getDeclineReasonsCLActionSuccess({ value: response?.data, status: response?.status }))
            yield put(resetMessaggioStateAction())
        }
    } catch (error) {
        if (error?.response?.status === 401) {
            yield put(setMessaggioAction({ status: ERRORE_UNAUTHORIZED }))
        } else if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
        } else {
            yield put(setMessaggioAction({ status: ERRORE_GENERICO_API }))
        }
        yield put(getDeclineReasonsCLActionSuccess({ value: error?.response?.data, status: error?.response?.status }))
    }
}

function* getDeclineReasonsCLWatcher() {
    yield takeEvery(GET_DECLINE_REASONS_CL, getDeclineReasonsCLWorker);
}

function* getCollectionCenterByLevelCLWorker() {
    generaLog("getCollectionCenterByLevelCLWorker", "log")
    yield put(getCollectionCenterByLevelCLActionSuccess({ value: undefined, status: LOADING }))
    yield put(setMessaggioAction({ status: LOADING }))
    let response, responseGeo;
    try {
        if (sessionStorage.CFTNS) {
            response = yield getCollectionCenterByLevelCLApiTS()
        } else {
            response = yield getCollectionCenterByLevelCLApiSPID()
        }
        if (response?.status === 200) {
            yield put(getCollectionCenterByLevelCLActionSuccess({ value: response?.data, status: response?.status }))
            yield put(getGeolocationsActionSuccess({ value: undefined, status: LOADING }))

            try {
                if (sessionStorage.CFTNS) {
                    responseGeo = yield apiProfilazioneTS.post("/geocode", response?.data, { headers: generateHeadersCfTns() });
                } else {
                    responseGeo = yield apiProfilazioneGW.post("/geocode", response?.data);

                }
                if (responseGeo?.status === 200) {
                    yield put(getGeolocationsActionSuccess({ value: responseGeo?.data, status: responseGeo?.status }))
                    yield put(resetMessaggioStateAction())
                }

            } catch (error) {
                if (error?.response?.status === 401) {
                    yield put(setMessaggioAction({ status: ERRORE_UNAUTHORIZED }))
                } else if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
                    yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
                } else {
                    yield put(setMessaggioAction({ status: ERRORE_GENERICO_API }))
                }
                yield put(getGeolocationsActionSuccess({ value: error?.response?.data, status: error?.response?.status }))
            }
        }
    } catch (error) {
        if (error?.response?.status === 401) {
            yield put(setMessaggioAction({ status: ERRORE_UNAUTHORIZED }))
        } else if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
        } else {
            yield put(setMessaggioAction({ status: ERRORE_GENERICO_API }))
        }
        yield put(getCollectionCenterByLevelCLActionSuccess({ value: error?.response?.data, status: error?.response?.status }))
    }
}

function* getCollectionCenterByLevelCLWatcher() {
    yield takeEvery(GET_COLLECTION_CENTER_BY_LEVEL_CL, getCollectionCenterByLevelCLWorker);
}

export function* screeningColonRettoWatchers() {
    yield all([
        checkScreeningCLWatcher(),
        postDeclineCLWatcher(),
        postAdhesionCLWatcher(),
        getDeclineReasonsCLWatcher(),
        getCollectionCenterByLevelCLWatcher(),
    ]);
}